module.exports = __webpack_public_path__ + "static/about-figures-4-643d52fce3b1cfcf974e91528df281e1.png";